const getDate = date => {
  date = date.split('-')
  const year = date.shift()
  date = date.join('/').split('T')
  date.pop()
  date.push(`/${year}`)
  return date.join('')
}

const getAmount = amount => {
  if (typeof amount !== 'string') {
    amount = amount.toString()
    const dollars = amount.slice(0, amount.length - 2)
    const cents = amount.slice(amount.length - 2, amount.length)
    return '$' + dollars + '.' + cents
  }
}

export { getDate, getAmount }
